import { Tag } from 'antd';
import styled from 'styled-components';

export const SkillTypeTag = styled(Tag)<{ type?: string }>`
	color: ${({ type }) => (type === 'A Plus' ? '#0093EE' : '#1CDCAB')};
	background-color: ${({ type }) => (type === 'A Plus' ? 'rgba(0, 147, 238, .2)' : 'rgba(28, 220, 171, .2)')};
	padding: 3px 6px;
	border: none;
	margin: 0 2px 2px 0;
	min-width: 70px;
	text-align: center;
`;
